import React, { useContext } from "react";
import trim from "lodash/trim";
import isEmpty from "lodash/isEmpty";
import styled from "styled-components";
import { Heading } from "grommet";
import PreviewContext from "../Layout/PreviewContext";
import NavLink from "../Link/NavLink";
import { breakpoint, border } from "../../theme";
import { getTagPagePath } from "../../tagPathUtils";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 200px;
	box-sizing: border-box;
	align-items: center;

	${breakpoint("tablet", true)`
		padding: 0 10px;
		${border({ style: "dashed", color: "border.medium" })`right`}
	`}

	${breakpoint("tablet")`
		padding-top: 10px;
		width: 100%;
		${border({ style: "dashed", color: "border.medium" })`top`}
	`}
`;

const TagsHeading = styled(Heading)`
	margin-bottom: 10px;
`;

const TagItem = styled.div`
	margin-bottom: 6px;
	margin-left: 8px;
`;

const Links = styled.div`
	display: flex;
	flex-direction: column;

	${breakpoint("tablet")`
		flex-direction: row;
	`}

  ${breakpoint("phone")`
		flex-wrap: wrap;
	`}
`;

const Tag = styled.span`
	font-style: italic;
	margin-right: 2px;
`;

const TagsTitle = <TagsHeading level={3} size="large" responsive={false}>תגיות</TagsHeading>;

const renderTag = (isPreview, tag, tagContentType) => isPreview ? <span>#{tag}</span> : <NavLink
	to={getTagPagePath(tagContentType, tag)}>
	#<Tag>{tag}</Tag>
</NavLink>;

const TagsContainer = ({ tags, tagContentType, sectionPath }) => {
	const isPreview = useContext(PreviewContext);

	return <Container>
		{!isPreview && sectionPath ?
			<NavLink to={`${sectionPath}/tags`}>{TagsTitle}</NavLink> : TagsTitle}

		< Links >
			{tags && tags.map((tag) =>
				!isEmpty(trim(tag)) ? <TagItem key={tag}>
					{renderTag(isPreview, tag, tagContentType)}
				</TagItem> : null
			)}
		</Links>
	</Container >;
};


export default TagsContainer;
